import apiClient from './apiService';
import {parseFiltersToQueryString} from "../utils/parseFiltersToQueryString";

class PaymentInformationService {
    constructor() {
        if (PaymentInformationService.instance) {
            return PaymentInformationService.instance;
        }
        PaymentInformationService.instance = this;
    }

    async getAll(page = 1, size = 10, filters = {}, sort = ['createdAt', 'desc']) {
        try {
            const queryString = parseFiltersToQueryString(filters);
            const response = await apiClient.get(
                `/payment-information?page=${page}&size=${size}&${queryString}&sort=${sort.join(',')}`
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching payment information:", error);
            throw error;
        }
    }

    async get(id) {
        try {
            const response = await apiClient.get(`/payment-information/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching payment information with ID ${id}:`, error);
            throw error;
        }
    }

    async create(paymentData) {
        try {
            const response = await apiClient.post('/payment-information', paymentData, {
                headers: {'Content-Type': 'multipart/form-data'},
            });
            return response.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw error.response.data;
            }
            throw error.response;
        }
    }

    async update(id, paymentData) {
        try {
            const response = await apiClient.put(`/payment-information/${id}`, paymentData, {
                headers: {'Content-Type': 'multipart/form-data'},
            });
            return response.data;
        } catch (error) {
            console.error(`Error updating payment information with ID ${id}:`, error);
            throw error;
        }
    }

    async delete(id) {
        try {
            await apiClient.delete(`/payment-information/${id}`);
            return {success: true, message: "Payment information deleted successfully"};
        } catch (error) {
            console.error(`Error deleting payment information with ID ${id}:`, error);
            throw error;
        }
    }

    static getInstance() {
        if (!PaymentInformationService.instance) {
            PaymentInformationService.instance = new PaymentInformationService();
        }
        return PaymentInformationService.instance;
    }
}

export default PaymentInformationService.getInstance();